import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

export function useGroupManagerRoleFlag(): boolean {
  const user = useUser();
  return useFliptBoolean("group-manager-role", false, user?.email);
}
